import PlatformError from "../PlatformError";

export default new PlatformError(
  "WARN",
  "Your session has timed out, please use the original link to start from the beginning.",
  "Warning",
  "User state timed out after 1h",
  "app.error.stalestate"
);
